import { default as logind0Qqeooh07Meta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/admin/login.vue?macro=true";
import { default as regist_mfapGooDlm156Meta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/admin/regist_mfa.vue?macro=true";
import { default as send_emailgtAgXpK3mtMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/admin/send_email.vue?macro=true";
import { default as signupJqDHuga3v5Meta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/admin/signup.vue?macro=true";
import { default as tooluhhCvghyCgMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/admin/tool.vue?macro=true";
import { default as verify_mfa3O8u5mo7sfMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/admin/verify_mfa.vue?macro=true";
import { default as indexWsl07Py48iMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/article/[id]/index.vue?macro=true";
import { default as indexAMVR1MppuyMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/document/[id]/index.vue?macro=true";
import { default as forgot_passwordRq7QUvSihWMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/forgot_password.vue?macro=true";
import { default as indexXMghH72TH4Meta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/index.vue?macro=true";
import { default as hostAKcx5rHD6eMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/live/[id]/host.vue?macro=true";
import { default as indexZ6lrMP6ZLvMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/live/[id]/index.vue?macro=true";
import { default as resultdkGbdgWigmMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/live/[id]/result.vue?macro=true";
import { default as _91id_937mnQNjVQ0kMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/livearchive/[id].vue?macro=true";
import { default as _91id_93TtRczRcjfLMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/liveschedule/[id].vue?macro=true";
import { default as login_mailVEhpGw5GdGMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/login_mail.vue?macro=true";
import { default as loginn9mrUV14R2Meta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/login.vue?macro=true";
import { default as indexkt7QkagmjtMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/mail_refusal/[userId]/[accountId]/[token]/index.vue?macro=true";
import { default as embedULW98ihf3yMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/movie/[id]/embed.vue?macro=true";
import { default as indexzTwvbf4FUlMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/movie/[id]/index.vue?macro=true";
import { default as activityZnMUc6UxPRMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/mypage/activity.vue?macro=true";
import { default as emailfOq3CDFhgrMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/mypage/email.vue?macro=true";
import { default as indexKJ25IUbbwMMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/mypage/index.vue?macro=true";
import { default as mail_45settingacKsj7b5hIMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/mypage/mail-setting.vue?macro=true";
import { default as personalinfo6TTdE9Xr8qMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/mypage/personalinfo.vue?macro=true";
import { default as profileNl6CDcgUJTMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/mypage/profile.vue?macro=true";
import { default as createEnGwZA49ZGMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/payment/create.vue?macro=true";
import { default as history7i5eXbTFoTMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/payment/history.vue?macro=true";
import { default as indextW5Be7sUH9Meta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/payment/index.vue?macro=true";
import { default as addpaymentDXArqP5HBnMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/addpayment.vue?macro=true";
import { default as indexX7HaAFvkYhMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/article/[contentId]/index.vue?macro=true";
import { default as edit4kkWZ5e3U1Meta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/bulk-delivery/[deliveryId]/edit.vue?macro=true";
import { default as viewPswtCdByh4Meta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/bulk-delivery/[deliveryId]/view.vue?macro=true";
import { default as createXkXH5eG6SLMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/bulk-delivery/create.vue?macro=true";
import { default as completesW3S5GIfwgMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/cancel/complete.vue?macro=true";
import { default as confirmZaJN544jSMMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/cancel/confirm.vue?macro=true";
import { default as noticeocPvnygYG8Meta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/cancel/notice.vue?macro=true";
import { default as reasonPgWqfryCjvMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/cancel/reason.vue?macro=true";
import { default as starthlhSNoMOrIMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/cancel/start.vue?macro=true";
import { default as indexjvPGDBbHRdMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/contract/index.vue?macro=true";
import { default as indexh5wtssseCzMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/contract/payment/index.vue?macro=true";
import { default as newZtC8agqjbyMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/contract/payment/new.vue?macro=true";
import { default as editGjRifdfFgMMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/article/[contentId]/edit.vue?macro=true";
import { default as createIHgIceHL5zMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/article/create.vue?macro=true";
import { default as previewb1Qstal4eeMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/article/preview.vue?macro=true";
import { default as completeGwgb7Zmwb2Meta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/complete.vue?macro=true";
import { default as editC4Feea3JceMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/document/[contentId]/edit.vue?macro=true";
import { default as createx4X1lzIP0gMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/document/create.vue?macro=true";
import { default as edit2CVxn6OxfUMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/live/[contentId]/edit.vue?macro=true";
import { default as createNM6LflVeKKMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/live/create.vue?macro=true";
import { default as editJlKNPkn16VMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/livearchive/[contentId]/edit.vue?macro=true";
import { default as editwtSXXROGNWMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/movie/[contentId]/edit.vue?macro=true";
import { default as creates2qPeuWwYHMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/movie/create.vue?macro=true";
import { default as historyma1XlulGeBMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/offer/[campaignId]/history.vue?macro=true";
import { default as createKlJ8S3lejMMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/offer/create.vue?macro=true";
import { default as edit5SIfklITIjMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/offer/edit.vue?macro=true";
import { default as indexA6UVoPlMZzMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/document/[contentId]/index.vue?macro=true";
import { default as indexWuTtb94UTfMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/edit/index.vue?macro=true";
import { default as indexv97DdaNqmIMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/index.vue?macro=true";
import { default as addpaymentsq42VhWgW6Meta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/join/addpayment.vue?macro=true";
import { default as agreementGFEsJTPCAHMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/join/agreement.vue?macro=true";
import { default as complete0yCd5pXbWvMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/join/complete.vue?macro=true";
import { default as confirmOHzc6ixkgiMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/join/confirm.vue?macro=true";
import { default as documents9wlJZrMmxDMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/join/documents.vue?macro=true";
import { default as payment_45bankDTelTLt7h2Meta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/join/payment-bank.vue?macro=true";
import { default as payment_45cardzpYvXwfe8UMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/join/payment-card.vue?macro=true";
import { default as payment_45methodWLUKCmDqo5Meta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/join/payment-method.vue?macro=true";
import { default as personalinfo07Z9455hNFMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/join/personalinfo.vue?macro=true";
import { default as createxCnAO2BpJXMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/library/create.vue?macro=true";
import { default as edit4Muye1m9ZjMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/library/edit.vue?macro=true";
import { default as hostY5lk939LDAMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/live/[[contentId]]/host.vue?macro=true";
import { default as chasingA6AMNAhxFeMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/live/[contentId]/chasing.vue?macro=true";
import { default as indexyqggVynpr9Meta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/live/[contentId]/index.vue?macro=true";
import { default as result1CrO4LwJ8pMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/live/[contentId]/result.vue?macro=true";
import { default as indexhE8evGGaLRMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/livearchive/[contentId]/index.vue?macro=true";
import { default as indexTj5ezZ4UOpMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/liveschedule/[contentId]/index.vue?macro=true";
import { default as detailUJ6csHpZELMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/member/[memberId]/detail.vue?macro=true";
import { default as embedn4LBFd02fzMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/movie/[contentId]/embed.vue?macro=true";
import { default as indexFBLyS66WD7Meta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/movie/[contentId]/index.vue?macro=true";
import { default as paymentpPMmpJbGdkMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/payment.vue?macro=true";
import { default as editkJCxeglNl1Meta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/price/[priceId]/edit.vue?macro=true";
import { default as createOEcRhcoskGMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/price/create.vue?macro=true";
import { default as completecmR7yrUJ5PMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/review/complete.vue?macro=true";
import { default as indexCTMb6bIQ4TMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/review/index.vue?macro=true";
import { default as index8GQbyMPh8PMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/reviews/index.vue?macro=true";
import { default as indexoiDqAR4PBgMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/selection/[selectionId]/index.vue?macro=true";
import { default as edit49PG8u0rYPMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/step-delivery/[deliveryId]/edit.vue?macro=true";
import { default as viewbFvnkb2bXSMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/step-delivery/[deliveryId]/view.vue?macro=true";
import { default as createX1CJgJ8s1zMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/step-delivery/create.vue?macro=true";
import { default as editSscvfP2vQ3Meta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/talk/[talkRoomId]/edit.vue?macro=true";
import { default as editdm0vlkjdo2KyMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/talk/[talkRoomId]/editdm.vue?macro=true";
import { default as create93acIT57TkMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/talk/create.vue?macro=true";
import { default as joiningLi8xx6I92EMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plans/joining.vue?macro=true";
import { default as register_mail9NaH0gVQZJMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/register_mail.vue?macro=true";
import { default as registercRMKpYNT9DMeta } from "/home/runner/work/fincs-webfront/fincs-webfront/src/pages/register.vue?macro=true";
export default [
  {
    name: "admin-login",
    path: "/admin/login",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/admin/login.vue")
  },
  {
    name: "admin-regist_mfa",
    path: "/admin/regist_mfa",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/admin/regist_mfa.vue")
  },
  {
    name: "admin-send_email",
    path: "/admin/send_email",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/admin/send_email.vue")
  },
  {
    name: "admin-signup",
    path: "/admin/signup",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/admin/signup.vue")
  },
  {
    name: "admin-tool",
    path: "/admin/tool",
    meta: tooluhhCvghyCgMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/admin/tool.vue")
  },
  {
    name: "admin-verify_mfa",
    path: "/admin/verify_mfa",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/admin/verify_mfa.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/article/[id]/index.vue")
  },
  {
    name: "document-id",
    path: "/document/:id()",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/document/[id]/index.vue")
  },
  {
    name: "forgot_password",
    path: "/forgot_password",
    meta: forgot_passwordRq7QUvSihWMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/forgot_password.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/index.vue")
  },
  {
    name: "live-id-host",
    path: "/live/:id()/host",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/live/[id]/host.vue")
  },
  {
    name: "live-id",
    path: "/live/:id()",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/live/[id]/index.vue")
  },
  {
    name: "live-id-result",
    path: "/live/:id()/result",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/live/[id]/result.vue")
  },
  {
    name: "livearchive-id",
    path: "/livearchive/:id()",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/livearchive/[id].vue")
  },
  {
    name: "liveschedule-id",
    path: "/liveschedule/:id()",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/liveschedule/[id].vue")
  },
  {
    name: "login_mail",
    path: "/login_mail",
    meta: login_mailVEhpGw5GdGMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/login_mail.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginn9mrUV14R2Meta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/login.vue")
  },
  {
    name: "mail_refusal-userId-accountId-token",
    path: "/mail_refusal/:userId()/:accountId()/:token()",
    meta: indexkt7QkagmjtMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/mail_refusal/[userId]/[accountId]/[token]/index.vue")
  },
  {
    name: "movie-id-embed",
    path: "/movie/:id()/embed",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/movie/[id]/embed.vue")
  },
  {
    name: "movie-id",
    path: "/movie/:id()",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/movie/[id]/index.vue")
  },
  {
    name: "mypage-activity",
    path: "/mypage/activity",
    meta: activityZnMUc6UxPRMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/mypage/activity.vue")
  },
  {
    name: "mypage-email",
    path: "/mypage/email",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/mypage/email.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: indexKJ25IUbbwMMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/mypage/index.vue")
  },
  {
    name: "mypage-mail-setting",
    path: "/mypage/mail-setting",
    meta: mail_45settingacKsj7b5hIMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/mypage/mail-setting.vue")
  },
  {
    name: "mypage-personalinfo",
    path: "/mypage/personalinfo",
    meta: personalinfo6TTdE9Xr8qMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/mypage/personalinfo.vue")
  },
  {
    name: "mypage-profile",
    path: "/mypage/profile",
    meta: profileNl6CDcgUJTMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/mypage/profile.vue")
  },
  {
    name: "payment-create",
    path: "/payment/create",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/payment/create.vue")
  },
  {
    name: "payment-history",
    path: "/payment/history",
    meta: history7i5eXbTFoTMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/payment/history.vue")
  },
  {
    name: "payment",
    path: "/payment",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/payment/index.vue")
  },
  {
    name: "plan-id-addpayment",
    path: "/plan/:id()/addpayment",
    meta: addpaymentDXArqP5HBnMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/addpayment.vue")
  },
  {
    name: "plan-id-article-contentId",
    path: "/plan/:id()/article/:contentId()",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/article/[contentId]/index.vue")
  },
  {
    name: "plan-id-bulk-delivery-deliveryId-edit",
    path: "/plan/:id()/bulk-delivery/:deliveryId()/edit",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/bulk-delivery/[deliveryId]/edit.vue")
  },
  {
    name: "plan-id-bulk-delivery-deliveryId-view",
    path: "/plan/:id()/bulk-delivery/:deliveryId()/view",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/bulk-delivery/[deliveryId]/view.vue")
  },
  {
    name: "plan-id-bulk-delivery-create",
    path: "/plan/:id()/bulk-delivery/create",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/bulk-delivery/create.vue")
  },
  {
    name: "plan-id-cancel-complete",
    path: "/plan/:id()/cancel/complete",
    meta: completesW3S5GIfwgMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/cancel/complete.vue")
  },
  {
    name: "plan-id-cancel-confirm",
    path: "/plan/:id()/cancel/confirm",
    meta: confirmZaJN544jSMMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/cancel/confirm.vue")
  },
  {
    name: "plan-id-cancel-notice",
    path: "/plan/:id()/cancel/notice",
    meta: noticeocPvnygYG8Meta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/cancel/notice.vue")
  },
  {
    name: "plan-id-cancel-reason",
    path: "/plan/:id()/cancel/reason",
    meta: reasonPgWqfryCjvMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/cancel/reason.vue")
  },
  {
    name: "plan-id-cancel-start",
    path: "/plan/:id()/cancel/start",
    meta: starthlhSNoMOrIMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/cancel/start.vue")
  },
  {
    name: "plan-id-contract",
    path: "/plan/:id()/contract",
    meta: indexjvPGDBbHRdMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/contract/index.vue")
  },
  {
    name: "plan-id-contract-payment",
    path: "/plan/:id()/contract/payment",
    meta: indexh5wtssseCzMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/contract/payment/index.vue")
  },
  {
    name: "plan-id-contract-payment-new",
    path: "/plan/:id()/contract/payment/new",
    meta: newZtC8agqjbyMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/contract/payment/new.vue")
  },
  {
    name: "plan-id-distribute-article-contentId-edit",
    path: "/plan/:id()/distribute/article/:contentId()/edit",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/article/[contentId]/edit.vue")
  },
  {
    name: "plan-id-distribute-article-create",
    path: "/plan/:id()/distribute/article/create",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/article/create.vue")
  },
  {
    name: "plan-id-distribute-article-preview",
    path: "/plan/:id()/distribute/article/preview",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/article/preview.vue")
  },
  {
    name: "plan-id-distribute-complete",
    path: "/plan/:id()/distribute/complete",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/complete.vue")
  },
  {
    name: "plan-id-distribute-document-contentId-edit",
    path: "/plan/:id()/distribute/document/:contentId()/edit",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/document/[contentId]/edit.vue")
  },
  {
    name: "plan-id-distribute-document-create",
    path: "/plan/:id()/distribute/document/create",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/document/create.vue")
  },
  {
    name: "plan-id-distribute-live-contentId-edit",
    path: "/plan/:id()/distribute/live/:contentId()/edit",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/live/[contentId]/edit.vue")
  },
  {
    name: "plan-id-distribute-live-create",
    path: "/plan/:id()/distribute/live/create",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/live/create.vue")
  },
  {
    name: "plan-id-distribute-livearchive-contentId-edit",
    path: "/plan/:id()/distribute/livearchive/:contentId()/edit",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/livearchive/[contentId]/edit.vue")
  },
  {
    name: "plan-id-distribute-movie-contentId-edit",
    path: "/plan/:id()/distribute/movie/:contentId()/edit",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/movie/[contentId]/edit.vue")
  },
  {
    name: "plan-id-distribute-movie-create",
    path: "/plan/:id()/distribute/movie/create",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/movie/create.vue")
  },
  {
    name: "plan-id-distribute-offer-campaignId-history",
    path: "/plan/:id()/distribute/offer/:campaignId()/history",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/offer/[campaignId]/history.vue")
  },
  {
    name: "plan-id-distribute-offer-create",
    path: "/plan/:id()/distribute/offer/create",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/offer/create.vue")
  },
  {
    name: "plan-id-distribute-offer-edit",
    path: "/plan/:id()/distribute/offer/edit",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/distribute/offer/edit.vue")
  },
  {
    name: "plan-id-document-contentId",
    path: "/plan/:id()/document/:contentId()",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/document/[contentId]/index.vue")
  },
  {
    name: "plan-id-edit",
    path: "/plan/:id()/edit",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/edit/index.vue")
  },
  {
    name: "plan-id",
    path: "/plan/:id()",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/index.vue")
  },
  {
    name: "plan-id-join-addpayment",
    path: "/plan/:id()/join/addpayment",
    meta: addpaymentsq42VhWgW6Meta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/join/addpayment.vue")
  },
  {
    name: "plan-id-join-agreement",
    path: "/plan/:id()/join/agreement",
    meta: agreementGFEsJTPCAHMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/join/agreement.vue")
  },
  {
    name: "plan-id-join-complete",
    path: "/plan/:id()/join/complete",
    meta: complete0yCd5pXbWvMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/join/complete.vue")
  },
  {
    name: "plan-id-join-confirm",
    path: "/plan/:id()/join/confirm",
    meta: confirmOHzc6ixkgiMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/join/confirm.vue")
  },
  {
    name: "plan-id-join-documents",
    path: "/plan/:id()/join/documents",
    meta: documents9wlJZrMmxDMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/join/documents.vue")
  },
  {
    name: "plan-id-join-payment-bank",
    path: "/plan/:id()/join/payment-bank",
    meta: payment_45bankDTelTLt7h2Meta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/join/payment-bank.vue")
  },
  {
    name: "plan-id-join-payment-card",
    path: "/plan/:id()/join/payment-card",
    meta: payment_45cardzpYvXwfe8UMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/join/payment-card.vue")
  },
  {
    name: "plan-id-join-payment-method",
    path: "/plan/:id()/join/payment-method",
    meta: payment_45methodWLUKCmDqo5Meta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/join/payment-method.vue")
  },
  {
    name: "plan-id-join-personalinfo",
    path: "/plan/:id()/join/personalinfo",
    meta: personalinfo07Z9455hNFMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/join/personalinfo.vue")
  },
  {
    name: "plan-id-library-create",
    path: "/plan/:id()/library/create",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/library/create.vue")
  },
  {
    name: "plan-id-library-edit",
    path: "/plan/:id()/library/edit",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/library/edit.vue")
  },
  {
    name: "plan-id-live-contentId-host",
    path: "/plan/:id()/live/:contentId?/host",
    meta: hostY5lk939LDAMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/live/[[contentId]]/host.vue")
  },
  {
    name: "plan-id-live-contentId-chasing",
    path: "/plan/:id()/live/:contentId()/chasing",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/live/[contentId]/chasing.vue")
  },
  {
    name: "plan-id-live-contentId",
    path: "/plan/:id()/live/:contentId()",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/live/[contentId]/index.vue")
  },
  {
    name: "plan-id-live-contentId-result",
    path: "/plan/:id()/live/:contentId()/result",
    meta: result1CrO4LwJ8pMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/live/[contentId]/result.vue")
  },
  {
    name: "plan-id-livearchive-contentId",
    path: "/plan/:id()/livearchive/:contentId()",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/livearchive/[contentId]/index.vue")
  },
  {
    name: "plan-id-liveschedule-contentId",
    path: "/plan/:id()/liveschedule/:contentId()",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/liveschedule/[contentId]/index.vue")
  },
  {
    name: "plan-id-member-memberId-detail",
    path: "/plan/:id()/member/:memberId()/detail",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/member/[memberId]/detail.vue")
  },
  {
    name: "plan-id-movie-contentId-embed",
    path: "/plan/:id()/movie/:contentId()/embed",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/movie/[contentId]/embed.vue")
  },
  {
    name: "plan-id-movie-contentId",
    path: "/plan/:id()/movie/:contentId()",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/movie/[contentId]/index.vue")
  },
  {
    name: "plan-id-payment",
    path: "/plan/:id()/payment",
    meta: paymentpPMmpJbGdkMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/payment.vue")
  },
  {
    name: "plan-id-price-priceId-edit",
    path: "/plan/:id()/price/:priceId()/edit",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/price/[priceId]/edit.vue")
  },
  {
    name: "plan-id-price-create",
    path: "/plan/:id()/price/create",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/price/create.vue")
  },
  {
    name: "plan-id-review-complete",
    path: "/plan/:id()/review/complete",
    meta: completecmR7yrUJ5PMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/review/complete.vue")
  },
  {
    name: "plan-id-review",
    path: "/plan/:id()/review",
    meta: indexCTMb6bIQ4TMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/review/index.vue")
  },
  {
    name: "plan-id-reviews",
    path: "/plan/:id()/reviews",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/reviews/index.vue")
  },
  {
    name: "plan-id-selection-selectionId",
    path: "/plan/:id()/selection/:selectionId()",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/selection/[selectionId]/index.vue")
  },
  {
    name: "plan-id-step-delivery-deliveryId-edit",
    path: "/plan/:id()/step-delivery/:deliveryId()/edit",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/step-delivery/[deliveryId]/edit.vue")
  },
  {
    name: "plan-id-step-delivery-deliveryId-view",
    path: "/plan/:id()/step-delivery/:deliveryId()/view",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/step-delivery/[deliveryId]/view.vue")
  },
  {
    name: "plan-id-step-delivery-create",
    path: "/plan/:id()/step-delivery/create",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/step-delivery/create.vue")
  },
  {
    name: "plan-id-talk-talkRoomId-edit",
    path: "/plan/:id()/talk/:talkRoomId()/edit",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/talk/[talkRoomId]/edit.vue")
  },
  {
    name: "plan-id-talk-talkRoomId-editdm",
    path: "/plan/:id()/talk/:talkRoomId()/editdm",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/talk/[talkRoomId]/editdm.vue")
  },
  {
    name: "plan-id-talk-create",
    path: "/plan/:id()/talk/create",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plan/[id]/talk/create.vue")
  },
  {
    name: "plans-joining",
    path: "/plans/joining",
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/plans/joining.vue")
  },
  {
    name: "register_mail",
    path: "/register_mail",
    meta: register_mail9NaH0gVQZJMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/register_mail.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registercRMKpYNT9DMeta || {},
    component: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/pages/register.vue")
  }
]